<template>
    <div class="main-content-container container-fluid px-4">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-12 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">Demande de régie</span>
          <h3 class="page-title">Gestion des demandes de régie</h3>
       </div>
      </div>
      <!-- Table -->
      <div class="row">
        <div class="col">
          <div
            class="card card-small mb-4 mt-3"
            v-if="loading || !user.connected"
          >
            <div class="card-body">
              <spinner-dot />
            </div>
          </div>
          <div v-else>
            <div class="card card-small mb-4 mt-3">
              <div class="header-data-table">
                <h5 class="header-data-table__heading">Liste des demandes</h5>
              </div>
              <RegieRequestFilter :statusList="statusList" />
              <change-date-dialog
                :dialog="dialog"
                :toggleDialog="toggleDialog"
                :request="requestToEdit"
              />
              <div class="card-body">
                <data-table
                  :data="regieGridData"
                  :fields="gridColumnsTitle"
                  :selectedFields="gridFields"
                  :fieldsGrid="gridColumnsFields"
                  :tableState="state"
                  :count="count"
                ></data-table>
              </div>
            </div>
          </div>
          <simple-modal ref="reasonModal" :motif="selectedMotif" />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import SpinnerDot from "../../components/layout/Loading/spinner-dot";
  import DataTable from "../../components/regie/dataTable";
  import SimpleModal from "../../components/abscenceRequest/SimpleModal";
  import absceneRequestGrid from "../../data/dataTable/absceneRequestGrid.json";
  import RegieRequestFilter from "./RegieRequestFilter.vue";
  import ChangeDateDialog from "../absenceRequest/ChangeDateDialog";
  export default {
    name: "regie-request-management",
    components: {
      SimpleModal,
      DataTable,
      SpinnerDot,
      RegieRequestFilter,
      ChangeDateDialog
    },
    props: ["reference"],
    data() {
      return {
        dialog: false,
        regieHistory: [],
        requestToEdit: {},
        count: 0,
        model: {},
        selectedMotif: "",
        // all values available for the table
        gridColumnsFields: absceneRequestGrid.grid,
        gridColumnsTitle: absceneRequestGrid.grid.map(grid => grid.title),
        loading: true,
        gridFields: [
          "Demandeur",
          "Structure",
          "Détails",
          "Montant",
          "Date",
          "Statut",
          "Action"
        ],
  
        regieFildesGridFill: {
          "Demandeur": request => request.applicantFirstName + " " + request.applicantLastName,
          "Structure": request => request.structureName,
          "Détails": request => request.description,
          "Montant": request => `${request.effectiveAmount ? request.effectiveAmount : request.amount} €`,
          "Date": request => new Date(request.creationDate).toLocaleDateString("fr-FR"),
          Statut: request => request.status || "En attente...",
          Action: request => {
            return [
              {
                component: "button-td",
                class: "btn-accent",
                content: "Voir la demande",
                action: () => this.goToRequest(request),
                id: request.declineReason
              }
            ];
          }
        },
        state: {
          page: 1,
          perPage: 10,
          field: "Date",
          ascending: false
        },
        statusList: ["PENDING", "ACCEPTED", "REFUSED", "TREATED"],
        filterQuery: {},
        filteredDaysOff: [],
        regieGridData: []
      };
    },
  
    watch: {
      state: {
        handler() {
          this.regieFetch();
        },
        deep: true
      },
      filterQuery() {
        // searchregieFetch
        if (Object.keys(this.filterQuery).length === 0) {
          this.regieFetch();
        } else {
          this.searchregieFetch();
        }
      },
      regieHistory() {
        
        if (this.filterQuery.dates) {
          const { from, to } = this.filterQuery.dates;
          const filtered = this.regieHistory.filter(item => {
            const { dates } = item;
            if (from && to) {
              return dates[0].from >= from && dates[0].to <= to;
            } else if (!from) {
              return dates[0].to <= to;
            } else if (!to) {
              
              return dates[0].from >= from;
            }
            return true;
          });
          this.filteredDaysOff = this.filterQuery.status
            ? this.filterQuery.status === "PENDING"
              ? filtered.filter(item => item.status === undefined)
              : filtered.filter(item => item.status === this.filterQuery.status)
            : filtered;
        } else {
          this.filteredDaysOff = this.filterQuery.status
            ? this.filterQuery.status === "PENDING"
              ? this.regieHistory.filter(item => item.status === undefined)
              : this.regieHistory.filter(
                  item => item.status === this.filterQuery.status
                )
            : this.regieHistory;
        }
      },
      filteredDaysOff() {
        this.regieGridData = this.filteredDaysOff.map(user => {
          const res = {};
          this.gridFields.forEach(field => {
            if (this.regieFildesGridFill[field]) {
              res[field] = this.regieFildesGridFill[field](user);
            }
          });
          return res;
        });
      }
    },
  
    computed: {
      user() {
        return this.$store.state.user.informations;
      }
    },
  
    methods: {
      toggleDialog() {
        this.dialog = !this.dialog;
      },
      cancel_demand_with_restaure(request, numberOfDays) {
        const model = {
          status: "CANCELED",
          userReference: this.user.reference,
          motif: "Annulée par le comptable"
        };
        this.$services.absenceRequest
          .confirmRequest(request.reference, model)
          .then(({ data }) => {
            this.request = data;
            this.alreadyAnswered(request);
            this.$miniToastr.success("Cette demande a été annulée");
            this.regieFetch();
          })
          .catch(() => (this.loading = false));
        this.$services.user
          .updateLeftVacations({
            selectedUsers: [request.userReference],
            days: Number(numberOfDays),
            mode: "INCREMENT"
          })
          .then(() => {
            this.$miniToastr.success(this.$t("user.edit.success"));
            this.selectedUsers = [];
            this.appliedToAll = false;
            this.fetchUsers();
          })
          .catch(() => (this.loading = false));
      },
      edit_demand(request) {
        this.requestToEdit = request;
        this.dialog = true;
      },
      alreadyAnswered(request) {
        const a = request.answers.find(
          answer => answer.userReference === this.user.reference
        );
        if (a.status !== "PENDING") {
          this.answered = true;
        }
      },
      
      cancel_demand(request) {
        const model = {
          status: "CANCELED",
          userReference: this.user.reference,
          motif: "Annulée par le comptable"
        };
  
        this.$services.absenceRequest
          .confirmRequest(request.reference, model)
          .then(({ data }) => {
            this.request = data;
            this.alreadyAnswered(request);
            this.$miniToastr.success("Cette demande a été annulée");
            this.regieFetch();
          })
          .catch(() => (this.loading = false));
      },
      check_compta() {
        const { permissions } = this.$store.state.user.informations;
        const permission = permissions.find(
          item => item.groupReference === "_compta"
        );
  
        return permission != undefined;
      },
      showReason(reason) {
        this.selectedMotif = reason;
        this.$refs.reasonModal.openModal();
      },
      goToLeaveRequest(request) {
        this.$router.push(`/demandes/repondre/${request.reference}`);
      },
      goToRequest(request) {
        this.$router.push(`/regies/${request.reference}`);
      },
      async regieFetch() {
        this.loading = true;
        await this.$services.regieRequestService
          .findAllUnderCharge(
            this.user.reference,
            null,
            null,
            null,
            this.state.page,
            this.state.perPage,
            this.state.field,
            this.state.ascending,
            this.gridColumnsFields
          )
          .then(res => {
  
            this.loading = false;
            this.count = res.data.count;
            this.regieHistory = res.data.data;
          });
      },
      async searchregieFetch() {
        this.loading = true;
        await this.$services.regieRequestService
          .findAllUnderCharge(this.user.reference,          {
              status: this.filterQuery.status === "PENDING"
                ? undefined
                : this.filterQuery.status,
              firstName: this.filterQuery.firstName
                ? this.filterQuery.firstName
                : undefined,
              lastName: this.filterQuery.lastName
                ? this.filterQuery.lastName
                : undefined,
              applicantFirstName: this.filterQuery.applicantFirstName
                ? this.filterQuery.applicantFirstName
                : undefined,
              applicantLastName: this.filterQuery.applicantLastName
                ? this.filterQuery.applicantLastName
                : undefined,
              structureID: this.filterQuery.structureID
                ? this.filterQuery.structureID
                : undefined,
              dateFrom: this.filterQuery.startDate
                ? Date.parse(this.filterQuery.startDate)
                : undefined,
              dateTo: this.filterQuery.endDate
                ? Date.parse(this.filterQuery.endDate)
                : undefined,
            })
          .then(res => {
            this.loading = false;
            this.count = res.data.count;
            this.regieHistory = res.data;
          });
      }
    },
  
    mounted() {
      if (!this.reference) {
        this.model = { userReference: this.user.reference };
      } else {
        this.model = { userReference: this.reference };
      }
      this.filterQuery = this.$store.state.absenceRequest.filter;
      this.regieFetch();
      this.$root.$on("refresh", () => {
        this.regieFetch();
      });
      this.$root.$on("searchRequests", query => {
        this.filterQuery = query;
      });
    }
  };
  </script>
  
  <style></style>
  